document.addEventListener('DOMContentLoaded', () => {
  const CLICK_IDS = ['fbclid', 'gclid', 'ttclid', 'msclkid'];
  const canReveal = 'IntersectionObserver' in window
    && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const incoming = new URLSearchParams(window.location.search);

  const initReveal = (root) => {
    root.classList.add('is-reveal-ready');
    const observer = new IntersectionObserver((entries) => {
      for (const { isIntersecting, target } of entries) {
        if (!isIntersecting) continue;
        target.classList.add('is-visible');
        observer.unobserve(target);
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -10px 0px' });

    for (const item of root.querySelectorAll('[data-ppa-reveal]')) observer.observe(item);
  };

  const forwardAttribution = (root) => {
    for (const link of root.querySelectorAll('[data-ppa-product-link]')) {
      const destination = new URL(link.href, window.location.origin);
      for (const [key, value] of incoming) {
        if (/^utm_/i.test(key) || CLICK_IDS.includes(key)) destination.searchParams.set(key, value);
      }
      link.href = destination.toString();
    }
  };

  for (const root of document.querySelectorAll('[data-ppa-closing]')) {
    if (canReveal) initReveal(root);
    forwardAttribution(root);
  }
});
